import React from "react";

function MenuIcon() {
  return (
    <svg
      width={21.64}
      height={17.71}
      viewBox="0 0 21.64 17.71"
      overflow="visible"
    >
      <style>
        {
          ".prefix__st0{fill:none;stroke:#ff2839;stroke-width:1.25;stroke-miterlimit:10}"
        }
      </style>
      <path
        className="prefix__st0"
        d="M0 11.6h21.64M0 17.09h21.64M0 .62h21.64M0 6.05h21.64"
      />
    </svg>
  );
}

export default MenuIcon;
